import { Injectable } from '@angular/core';
import { Repository } from '@frontend-site/shared/utils';
import { createInitialState, ScreenSizeState } from './screen-size-state';
import { createStore, select, withProps } from '@ngneat/elf';
import { ScreenSize } from './screen-size.enum';

@Injectable({
    providedIn: 'root'
})
export class ScreenSizeRepository extends Repository<ScreenSizeState> {
    readonly screenSize$ = this.store.pipe(select((state: ScreenSizeState) => state.screenSize));

    constructor() {
        super(createStore({ name: 'ScreenSizeRepository' }, withProps<ScreenSizeState>(createInitialState())));
    }

    public setScreenSize(screenSize: ScreenSize) {
        this.update({ screenSize });
    }
}
